<nav class="shell">
  <a
    routerLink="/dashboard"
    routerLinkActive="active"
    [routerLinkActiveOptions]="{ exact: true }"
    class="item"
  >
    <fa-icon [icon]="iconDashboard"></fa-icon>
    <span>Dashboard</span>
  </a>

  <a routerLink="/assets" routerLinkActive="active" class="item">
    <fa-icon [icon]="iconAssets"></fa-icon>
    <span>Assets</span>
  </a>

  <a routerLink="/payments" routerLinkActive="active" class="item">
    <fa-icon [icon]="iconPayments"></fa-icon>
    <span>Payments</span>
  </a>
</nav>
